import React from 'react';
import { useOnomyHub } from '@onomy/react-hub';

import OnomyWalletSelect from './Modals/OnomyWalletSelect';

export function RequireOnomyWallet({ children }: { children: JSX.Element | JSX.Element[] }) {
  const { wallet } = useOnomyHub();
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (wallet.onomy.isConnected) return <>{children}</>;
  return <OnomyWalletSelect />;
}
